import * as React from "react";
import { PapiAuthenticationConsumer } from "./Api/PapiClient";
import { Button } from "antd";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { ButtonType } from "antd/lib/button";

interface Props extends WrappedComponentProps {
  type?: ButtonType;
  block?: boolean;
}

class LogoutButtonCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <PapiAuthenticationConsumer>
        {state => {
          return (
            <Button
              type={this.props.type}
              block={this.props.block}
              onClick={() => state.deauthenticate()}
            >
              {this.props.intl.formatMessage({ id: "logoutButton.text" })}
            </Button>
          );
        }}
      </PapiAuthenticationConsumer>
    );
  }
}

export const LogoutButton = injectIntl(LogoutButtonCmp);
